import { SearchObject } from "app/common/Model/SearchObject";
import { getFileById } from "app/services/FileDescriptionExtService";
import { getListPatientAdviceItem } from "app/services/PatientAdvice";
import { getListgetListImageTrement, pagingServiceRequestItemByPatientServiceRegisterInfo } from "app/services/ServiceRequestItemService";
import i18n from "i18n";
import { makeAutoObservable, runInAction } from "mobx";
import { toast } from "react-toastify";
import { generateRandomId } from "utils";

export default class TreamentInfoPatientStore {
  searchImageTreatmentPlan = {
    ...new SearchObject(),
    getReport: true,
    patientId: null,
    // fromDate: new Date(),
    // toDate: new Date(),
  };
  searchImageAdvice = {
    ...new SearchObject(),
    // fromDate: new Date(),
    // toDate: new Date(),
    patientId: null,
  };
  listImageTreatment = null;
  listPatientAdviceItem = [];
  totalElements = 0;
  totalPages = 0;
  imageUrls = {};
  isLoading = false;

  constructor() {
    makeAutoObservable(this);
  }

  pagingTreatments = async (patientId) => {
    if (this.searchImageTreatmentPlan.patientId !== patientId) {
      this.reset();
      this.searchImageTreatmentPlan.patientId = patientId;
    }

    const { ...otherData } = this.searchImageTreatmentPlan;
    runInAction(() => {
      this.isLoading = true;
    });

    try {
      const { data } = await pagingServiceRequestItemByPatientServiceRegisterInfo({ ...otherData, patientId });
      runInAction(() => {
        this.listImageTreatment = data.content;
        this.totalElements = data.totalElements;
        this.totalPages = data.totalPages;
      });
    } catch (error) {
      console.error(error);
      toast.error("Lấy dữ liệu khách hàng có lỗi");
    } finally {
      runInAction(() => {
        this.isLoading = false;
      });
    }
  };

  setPageIndex = (pageIndex) => {
    this.searchImageTreatmentPlan.pageIndex = pageIndex;
  };

  setPageSize = (pageSize) => {
    this.searchImageTreatmentPlan.pageSize = pageSize;
  };

  // Concurrent request control (Isolation + Concurrency Control)
  concurrencyLimit = 5;
  activeRequests = 0;
  requestQueue = [];

  reset = () => {
    // Revoke all object URLs to avoid memory leaks (Memory Control)
    Object.values(this.imageUrls).forEach((url) => {
      if (url && typeof url === "string" && url.startsWith("blob:")) {
        URL.revokeObjectURL(url);
      }
    });
    this.imageUrls = {};
    this.listImageTreatment = null;
    this.listPatientAdviceItem = [];
    this.requestQueue = [];
    this.activeRequests = 0;
  };

  // Cache-first + Cancelable request engine
  fetchImage = async (fileId, signal) => {
    if (this.imageUrls[fileId]) return this.imageUrls[fileId];

    return new Promise((resolve) => {
      const executeRequest = async () => {
        // Handle race conditions where image is already in queue or processing
        if (this.activeRequests >= this.concurrencyLimit) {
          this.requestQueue.push(executeRequest);
          return;
        }

        this.activeRequests++;
        try {
          if (signal?.aborted) {
            resolve();
            return;
          }

          const res = await getFileById(fileId, signal);
          if (res?.data) {
            const imageUrl = URL.createObjectURL(res.data);
            runInAction(() => {
              this.imageUrls[fileId] = imageUrl;
            });
            resolve(imageUrl);
          } else {
            throw new Error("No data received");
          }
        } catch (error) {
          if (error.name !== "AbortError" && error.message !== "Aborted") {
            console.error("Lỗi tải ảnh:", error);
            runInAction(() => {
              // Mark as processed but failed so UI can unblock
              this.imageUrls[fileId] = "FAILED";
            });
          }
          resolve("FAILED");
        } finally {
          this.activeRequests--;
          if (this.requestQueue.length > 0) {
            const nextRequest = this.requestQueue.shift();
            nextRequest();
          }
        }
      };

      executeRequest();
    });
  };

  getImageUrl = (fileId) => {
    const url = this.imageUrls[fileId];
    return url === "FAILED" ? null : url;
  };

  getListPatientAdviceItem = async (obj) => {
    if (this.searchImageAdvice.patientId !== obj.patientId) {
      this.reset();
      this.searchImageAdvice.patientId = obj.patientId;
    }

    runInAction(() => {
      this.isLoading = true;
    });

    try {
      const { data } = await getListPatientAdviceItem({
        ...this.searchImageAdvice,
        ...obj,
      });

      // Isolation: Don't fetch blobs here. Return IDs for lazy loading.
      const list = data?.flatMap((el) => 
        el?.attachmentIds?.map(id => ({
          fileId: id,
          name: el.name || "Ảnh tư vấn",
          id: generateRandomId()
        }))
      ) || [];

      runInAction(() => {
        this.listPatientAdviceItem = list;
      });
    } catch (error) {
      toast.error("Lấy dữ liệu tư vấn có lỗi");
    } finally {
      runInAction(() => {
        this.isLoading = false;
      });
    }
  };
}
